import { OptionSelectPart } from './aiAssistantModel'
import OptionList from './OptionList'

type Props = {
  part: OptionSelectPart
  interactive: boolean
  onSelect: (label: string) => void
}

/**
 * The standalone option question: clicking a choice sends its label as the
 * user's next message. The button list itself lives in OptionList so the
 * question-set pager can reuse it as a controlled picker.
 */
const OptionSelect = ({ part, interactive, onSelect }: Props) => {
  return (
    <div style={{ margin: '8px 0' }}>
      <p style={{ margin: '0 0 8px', fontWeight: 500 }}>{part.prompt}</p>
      <OptionList
        options={part.options}
        disabled={!interactive}
        onSelect={(option) => onSelect(option.label)}
      />
    </div>
  )
}

export default OptionSelect
